import styled from '@emotion/styled';
import { NsModal } from '@nuskin/foundation-ui-components';

export const SubscriptionRewardPopup = styled(NsModal)`
    .modalPopup.css-bdhsul-MuiTypography-root-MuiDialogTitle-root {
        padding: 0px !important;
    }
`;
export const ModalBody = styled.div`
    overflow-x: hidden !important;
`;
export const SubscriptionRewardImg = styled.div`
    display: flex !important;
    align-items: center;
    align-content: center;
    padding: 0px !important;
    img {
        padding: 0px;
    }
`;
export const VoucherDiv = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 0px 20px;
    border: 1px solid var(--color-primary-n-40-item-bg, #e0e0e0);
    border-radius: 16px;
    padding: 5px;
    margin: 8px;
`;
export const VoucherHeading = styled.div`
    display: flex;
    justify-content: center;
    padding: 20px;
    font-family: Lora;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0%;
    text-align: center;
`;
export const VoucherIcon = styled.div`
    align-items: center;
    width: 50%;
`;
export const VoucherDescription = styled.div`
    width: 50%;
    font-size: 12px;
`;
export const Footer = styled.div`
    margin: -10px;
    font-size: 15px;
    text-decoration: underline;
`;
export const HeaderDescription = styled.div`
    margin-top: -100px;
    padding: 10px;
    span {
        font-family: Inter;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 11%;
        text-align: center;
        color: #ffffff;
        display: flex;
        justify-content: center;
    }
    img {
        width: 100%;
        height: 100%;
        padding: 0px 100px;
    }
`;
export const HeaderSection = styled.div`
overflow: hidden;
margin: -24px;
}
`;
